import axios from 'axios';
import { TeamInsightsResponse } from './types';

interface FetchArgs {
    from: string;
    to: string;
}

export const fetchTeamInsights = async (args: FetchArgs): Promise<TeamInsightsResponse> => {
    const response = await axios.get<TeamInsightsResponse>('/api/team-insights', {
        params: { from: args.from, to: args.to },
    });
    return response.data;
};
